import React, {useEffect, useRef} from "react";
import {
    fileViewerSupported,
    formatDate,
    formatFileSize,
    getIconOfName,
    isMobileDevice
} from "../../../utils/utils";
import {FormattedMessage, useIntl} from "react-intl";
import {getFileUrl} from "../../../utils/consts";
import FileViewerPdf from "./fileViewerContent/file-viewer-pdf";
import useDownloadStore from "../../../store/downloadStore";

function FileViewer({file, maxHeightItems, showInfo = true, infoTop = true}) {
    const {addFileToQueue} = useDownloadStore(state => state.actions);

    const videoRef = useRef(null);
    const intl = useIntl();

    useEffect(() => {
        if (videoRef?.current) {
            videoRef.current.load();
        }
    }, [file])

    return (
        <div className="d-flex justify-content-center flex-column"
             onContextMenu={e => {
                 e.stopPropagation();
             }}>
            {showInfo && infoTop && <div className="d-flex flex-row justify-content-between">
                <span><FormattedMessage id="file-viewer.uploaded-on"/> {formatDate(file.uploadDate)}</span>
                <span style={{fontSize: "large", fontWeight: "bolder"}}>{formatFileSize(file.size)}</span>
            </div>}
            {showInfo && infoTop && <hr/>}
            <div style={{width: '100%', maxHeight: maxHeightItems ?? (window.innerHeight - 360)}} className="d-flex justify-content-center">
                {file.fileType.includes('video') &&
                    <div style={{maxHeight: maxHeightItems ?? (window.innerHeight - 360)}} className="d-flex justify-content-center flex-column">
                        <video ref={videoRef} id="video-player" style={{maxHeight: '100%', maxWidth: '100%'}} controls autoPlay={false} playsInline>
                            <source src={getFileUrl(file)} type={file.fileType || undefined}/>
                        </video>
                        {file.fileType.includes('video/x-matroska') &&
                            <div className="text-center" style={{maxWidth: '100%'}}>
                                <i className="fa-solid fa-triangle-exclamation text-warning me-1"></i>
                                <FormattedMessage id="file-viewer.mkv-warning"/>
                                <i className="fa-solid fa-triangle-exclamation text-warning ms-1"></i>
                            </div>}
                    </div>
                }
                {file.fileType.includes('image') &&
                    <img className="" src={getFileUrl(file)}
                         style={{objectFit:'contain', width: "100%", maxWidth: '100%', maxHeight: '100%'}}
                         alt={file.fileName}/>}
                {file.fileType.includes('audio') &&
                    <audio className={isMobileDevice() ? "col-12" : "col-7"} ref={videoRef} src={getFileUrl(file)}
                           controls></audio>
                }
                {file.fileType.includes('pdf') &&
                    <div style={{width: '100%', height: maxHeightItems ?? (window.innerHeight - 360)}}>
                        <FileViewerPdf file={file}/>
                    </div>
                }
                {!fileViewerSupported(file) &&
                    <div style={{fontSize: showInfo ? "xxx-large" : "large"}} className={showInfo ? "m-4" : "mb-1"}>
                        {showInfo && <div className="text-center">
                            <i className={getIconOfName(file) + " fa-2xl text-muted mb-3 text-center"}></i>
                        </div>}
                        {showInfo && <div style={{fontSize: "large"}} className="mt-4 text-muted text-center">
                            <FormattedMessage id="file-viewer.file-not-supported"/>
                        </div>}
                        <center>
                            <div>
                                {!showInfo && <small style={{fontSize: "small"}}>{file.fileName}</small>}
                            </div>
                            <button title={intl.formatMessage({id: "file-viewer.download-file"})}
                                    className="btn btn-outline-secondary btn-lg"
                                    onClick={() => addFileToQueue(file)}>
                                {!showInfo && <i className={getIconOfName(file) + " fa-xl text-muted me-2 text-center"}></i>}
                                <FormattedMessage id="file-viewer.download-file"/>
                                <i className="fa-solid fa-download ms-3 fa-xl"></i>
                            </button>
                        </center>
                    </div>
                }
            </div>
            {showInfo && !infoTop && <div className="d-flex flex-row justify-content-between mt-1">
                <span><FormattedMessage id="file-viewer.uploaded-on"/> {formatDate(file.uploadDate)}</span>
                <span style={{fontSize: "large", fontWeight: "bolder"}}>{formatFileSize(file.size)}</span>
            </div>}

        </div>
    )

}

export default FileViewer;
